import { Icon } from './Icon'

export function BuilderAttention() {
  return <span className="builder-attention"><Icon name="alert" size={15} />Action needed</span>
}
